import { CountryFields } from '@app/dev/terminal/components/countryFields/countryFields';
import DatePickerField from '@app/dev/terminal/components/dateBirthSelect';
import Config from '@app/dev/config/main';

const { registrationFormFiledConfigs } = Config.registrationFormConfigs;

export const personalFields = [
  {
    name: 'firstName',
    fieldName: 'First Name',
    enabled: registrationFormFiledConfigs.firstName,
    errorMessage: 'Name is not valid',
  },
  {
    name: 'lastName',
    fieldName: 'Last Name',
    enabled: registrationFormFiledConfigs.lastName,
    errorMessage: 'Last Name is not valid',
  },
  {
    name: 'birthDate',
    fieldName: 'Date Of Birth',
    enabled: registrationFormFiledConfigs.birthDate,
    custumViewComponent: DatePickerField,
    errorMessage: 'Email is not valid',
  },
  {
    name: 'country',
    fieldName: 'Country',
    className: 'country',
    enabled: registrationFormFiledConfigs.country,
    custumViewComponent: CountryFields,
    errorMessage: 'Field is required',
  },
];
